import AppRoutesV2 from "./routes/AppRoutesV2";

const App = () => {
    return <AppRoutesV2 />;
};

export default App;
